import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants'
import { ExtraService } from '../../core/services/extra.service';
import { Invites } from '../../core/models/invites';
import { AttendeesService } from '../../core/services/attendees.service';

@Component({
  selector: 'app-attendees2',
  templateUrl: './attendees2.component.html',
  styleUrls: ['./attendees2.component.css'],
  providers:[AttendeesService]
})
export class Attendees2Component implements OnInit {

  constructor(private attendeesService:AttendeesService,
    private extraService:ExtraService,private route: ActivatedRoute,private router:Router) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
      this.extraService.changeSideBar(true);
      this.route.params.subscribe(params => {
      let id = params['eventId'];
        if(id) {
          console.log(id);
          this.extraService.setCurrentEventId(id);                                                                  
        } 
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/attendees2/attendees2.component.ts